<p>config-dialog works!</p>
<button *ngIf="this.data.accion === 1" (click)="insertModuloInmo()">Comprar</button>
<button *ngIf="this.data.accion === 2">Ampliar</button>
<button *ngIf="this.data.accion === 3">Configurar</button>